import React, { useEffect, useState } from "react";
import { Card, Row, Col, Container } from "react-bootstrap";
import StarRating from "./StarRating";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FcRating, FcBusinesswoman } from "react-icons/fc";
import { MdStar, MdPeopleAlt, MdAttachMoney } from "react-icons/md";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { vasthuUrl } from "./Api";
import { GiLotus } from "react-icons/gi";

const HomeUserReview = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [vasthuRatingInfo, setVasthuRatingInfo] = useState({
    averageRating: 5,
    totalProfessional: 1,
  });
  const [starPercentages, setStarPercentages] = useState({
    fiveStar: 0,
    fourStar: 0,
    threeStar: 0,
    twoStar: 0,
    oneStar: 0,
  });

  useEffect(() => {
    try {
      vasthuUrl.get(`/openapi/getStarPercentage`).then((res) => {
        console.log("DATA", res.data);
        setVasthuRatingInfo({
          averageRating: res.data.average_rating,
          totalProfessional: res.data.professionalCount,
        });
        setStarPercentages({
          fiveStar: res.data.rating5count,
          fourStar: res.data.rating4count,
          threeStar: res.data.rating3count,
          twoStar: res.data.rating2count,
          oneStar: res.data.rating1count,
        });
      });
    } catch (error) {
      console.log("ERROE" + error);
    }
  }, []);

  const handleRating = (val) => {
    console.log("rating requested", val);
    navigate("vasthureview", { state: val });
  };

  return (
    <Container
      className="rounded p-1 my-2"
      style={{ border: "1px solid #ffb33e" }}
    >
      {/* <Row className="homeFeaturesTitle"> */}
      <center>
        <h1>
          <u>
            {t("CM.RT.TL")}
            <FcRating size={40} />{" "}
          </u>
        </h1>
      </center>
      {/* </Row> */}

      <Row className="appratings">
        <Col md="6" lg="6" xl="6">
          <div
            className="review-app-info"
            onClick={() => navigate("vasthureview")}
          >
            <div className="review-app-title">
              <h4>{t("CM_PUB_LOGO_TITLE")}</h4>
            </div>

            <div className="review-app-profile">
              <img
                alt="Edwin Diaz"
                // width="74"
                // height="64"
                src="https://images.unsplash.com/photo-1616435577207-ca90abc6b732?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1yZWxhdGVkfDF8fHxlbnwwfHx8fA%3D%3D&w=1000&q=80"
                style={{
                  width: "10rem",
                  height: "10rem",
                  borderRadius: "50% ",
                }}
              />

              <div className="review-profile-detail">
                <ul>
                  <li>
                    <p>
                      <MdStar size={25} /> {vasthuRatingInfo.averageRating}
                    </p>{" "}
                  </li>
                  <li>
                    <p>
                      <MdPeopleAlt size={25} />{" "}
                      {vasthuRatingInfo.totalProfessional}+{" "}
                      {t("TXT.CON.LO")}
                    </p>{" "}
                  </li>
                  <li>
                    <p>
                      <MdAttachMoney size={25} /> 100% {t("USR.HOM.REV.TEXT1")}
                    </p>{" "}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </Col>

        <Col md="6" lg="6" xl="6">
          <div className="circular-progressbar" style={{ cursor: "pointer" }}>
            <div className="star-circle" onClick={() => handleRating("1")}>
              <CircularProgressbar
                value={starPercentages.oneStar}
                text={`${starPercentages.oneStar}%`}
                styles={buildStyles({
                  pathColor: `#f74343`,
                  backgroundColor: "#3e98c7",
                })}
              />
              <p style={{ textAlign: "center", fontWeight: "bold" }}>
                1&#11088;
              </p>
            </div>

            <div className="star-circle" onClick={() => handleRating("2")}>
              <CircularProgressbar
                value={starPercentages.twoStar}
                text={`${starPercentages.twoStar}%`}
                styles={buildStyles({
                  pathColor: `#f7a032`,
                })}
              />
              <p style={{ textAlign: "center", fontWeight: "bold" }}>
                2&#11088;
              </p>
            </div>

            <div className="star-circle" onClick={() => handleRating("3")}>
              <CircularProgressbar
                value={starPercentages.threeStar}
                text={`${starPercentages.threeStar}%`}
                styles={buildStyles({
                  pathColor: `#f7db32`,
                })}
              />
              <p style={{ textAlign: "center", fontWeight: "bold" }}>
                3&#11088;
              </p>
            </div>

            <div className="star-circle" onClick={() => handleRating("4")}>
              <CircularProgressbar
                value={starPercentages.fourStar}
                text={`${starPercentages.fourStar}%`}
                styles={buildStyles({
                  pathColor: `#b1d628`,
                })}
              />
              <p style={{ textAlign: "center", fontWeight: "bold" }}>
                4&#11088;
              </p>
            </div>

            <div className="star-circle" onClick={() => handleRating("5")}>
              <CircularProgressbar
                value={starPercentages.fiveStar}
                text={`${starPercentages.fiveStar}%`}
                styles={buildStyles({
                  pathColor: `#54dc2b`,
                })}
              />
              <p style={{ textAlign: "center", fontWeight: "bold" }}>
                5&#11088;
              </p>
            </div>
          </div>
        </Col>
      </Row>

      <center>
        <h1>
          <u>
            {t("CM.USR.REV.TL")}
            <FcBusinesswoman size={45} />{" "}
          </u>
        </h1>
      </center>

      <Row className="userInfo" style={{ textAlign: "center" }}>
        <Col>
          <strong>1000+</strong>
          {t("USR.HOM.REV.TEXT2")}
        </Col>

        <Col>
          <strong>24x7</strong>
          {t("USR.HOM.REV.TEXT3")}
        </Col>

        <Col>
          <strong>100+</strong>
          {t("USR.HOM.REV.TEXT4")}
        </Col>
      </Row>
    </Container>
  );
};

export default HomeUserReview;
